/**
 * HC Dashboard - Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Ensure root element exists
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    'Failed to find the root element. Make sure there is a <div id="root"></div> in your HTML.'
  );
}

// Create React root and render
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Development info
if (import.meta.env.DEV) {
  console.log(
    '%c HC Dashboard v1.0.0 ',
    'background: #1890ff; color: white; padding: 4px 8px; border-radius: 4px;'
  );
  console.log('API URL:', import.meta.env.VITE_API_URL || '/api/v1/hc');
}
